export default __webpack_public_path__ + "static/client-1-f38d330d5955a2cb1b8e2711445e3187.webp";